import type { DisciplineStore } from './interfaces'

export const actions = {
  setDiscipline (this: DisciplineStore, payload: DisciplineStore['discipline']): void {
    this.discipline = payload
  },
  resetDiscipline (this: DisciplineStore): void {
    this.discipline = null
  },
  setDetails (this: DisciplineStore, payload: DisciplineStore['details']): void {
    this.details = payload
  },
  setCustomerGo (this: DisciplineStore, payload: DisciplineStore['customerGo']): void {
    this.customerGo = payload
  },
  setCustomerPremium (this: DisciplineStore, payload: DisciplineStore['customerPremium']): void {
    this.customerPremium = payload
  },
  setCustomerGoId (this: DisciplineStore, payload: DisciplineStore['customerGoId']): void {
    this.customerGoId = payload
  },
  setContextLoading (this: DisciplineStore, payload: DisciplineStore['contextLoading']): void {
    this.contextLoading = payload
  },
}
